import { styled } from "styled-components";
import { RadioOption } from "./Stepper";
import { useState } from "react";

export interface RadioButtonProp {
  radioOption: RadioOption;
  onClickOption: (name: string, label: string) => void;
  activeButton: string;
  label: string;
  name: string;
}

const RadioBtnWithSubText: React.FC<RadioButtonProp> = ({
  radioOption,
  onClickOption,
  activeButton,
  label,
  name,
}) => {
  const handleCheck = (label: string) => {
    onClickOption(name, label);
  };
  const isActive = (label: string) => {
    return label === activeButton;
  };

  return (
    <GeneralWrapper key={radioOption.label}>
      <span className="radioBtnTitle">{label}</span>
      <div className="radioWrapper">
        <img
          src={
            isActive(radioOption.label)
              ? "/assets/icons/checkboxOn.svg"
              : "/assets/icons/checkboxOff.svg"
          }
          alt={radioOption.label}
          onClick={() => handleCheck(radioOption.label)}
        />
      </div>
      <SubTitleWrapper>
        <span className="label">{radioOption.label}</span>
        <span className="subTitle">{radioOption.subText}</span>
      </SubTitleWrapper>
    </GeneralWrapper>
  );
};

export default RadioBtnWithSubText;

export const GeneralWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  .radioBtnTitle {
    font-weight: 500;
    font-size: 14px;
  }
`;
export const SubTitleWrapper = styled.div`
  display: flex;
  justify-items: center;
  flex-direction: column;

  .label {
    font-weight: 500;
    font-size: 14px;
  }
  .subTitle {
    font-size: 14px;
    font-weight: 400;
    color: #5e5e5e;
  }
`;
